import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

const API_BASE = ((import.meta as any).env?.VITE_SUPABASE_URL as string) || 'https://beta.crm-api.primetecia.com.br/api';

export interface DiscadoraKpiTopo {
  discadas: number; humanos: number; caixas: number; nao_atendeu: number; abandonos: number; pct: number;
  porConsultor: { nome: string; qtd: number }[];
}

/** Placar do dia do MOTOR da discadora (chip laranja do header). */
export function useDiscadoraKpiTopo(enabled = true) {
  return useQuery({
    queryKey: ['discadora-kpi-topo'],
    enabled,
    refetchInterval: 5 * 60_000,
    staleTime: 30_000,
    queryFn: async (): Promise<DiscadoraKpiTopo | null> => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.access_token) return null;
      const r = await fetch(`${API_BASE}/v1/discadora/kpi-topo`, { headers: { Authorization: `Bearer ${session.access_token}` } });
      if (!r.ok) return null;
      const j = await r.json();
      return (j?.data ?? null) as DiscadoraKpiTopo | null;
    },
  });
}
